import React, {useState} from 'react'
import WizButton from '../../../../components/button/WizButton'
import UnderLineInput from '../../../../components/input/UnderLineInput'
import WizSelect from '../../../../components/select/WizSelect'
import WizSelectButton from '../../../../components/button/WizSelectButton'

interface IProps {
    className?: string
    onClick: (e: string) => void
    onChangedSelect: (e: string) => void
    search: string
    exchange: string
    sortList: any
    sort: string
    onChangedSortBy: (e: string) => void
}

const LeaderSearchContainer: React.FC<IProps> = ({
    className,
    onClick,
    search,
    exchange = '',
    onChangedSelect,
    sortList,
    sort,
    onChangedSortBy,
}) => {
    const [inputText, setInputText] = useState('')

    return (
        <div className={'flex items-center justify-between md:block md:space-y-[50px]'}>
            <div className={'flex space-x-[10px] sm:block sm:space-y-[20px] sm:space-x-0'}>
                <WizSelect optionKey="exchange" onChange={onChangedSelect} value={exchange} />
                <WizSelectButton
                    data={sortList}
                    activeValue={sortList.find(list => list?.id === sort)}
                    onChange={e => {
                        onChangedSortBy(e.id)
                    }}
                />
            </div>
            <div className={`flex gap-[10px] w-full justify-end ${className}`}>
                <UnderLineInput
                    type={'text'}
                    inputClassName={'h-full'}
                    value={search || inputText}
                    onChanged={(e: string) => setInputText(e)}
                    onEnterKeyPress={() => onClick(inputText)}
                />
                <WizButton
                    text={'Reset'}
                    className={'text-white sm:hidden'}
                    type={'blue'}
                    size={'small'}
                    onClick={() => {
                        onClick('')
                        setInputText('')
                    }}
                />
                <WizButton
                    text={'Search'}
                    size={'small'}
                    onClick={() => {
                        onClick(inputText)
                    }}
                />
            </div>
        </div>
    )
}

export default LeaderSearchContainer
